module.exports = __webpack_public_path__ + "assets/img/intro-vip-b2.919aea0e.jpg";